import {api} from '../config/config'
// import qs from 'qs'

const prifixUrl = 'wx/';

export const getProductInfo = (productId) => {
    return api.get(`${prifixUrl}getProduct/${productId}`, {
        params: {
            productId: productId
        }
    })
}

export const prePay = (orderList) => {
    return api.post(`${prifixUrl}order/listCouponNew`, orderList)
}

export const submitOrder = (orderInfo) => {
    if (orderInfo.payAmount <= 0) { //无论怎样 留下一分钱
        orderInfo.payAmount = 1;
    }
    return api.post(`${prifixUrl}order/submit/web`, orderInfo)
}

export const loginByCode = (code, redisKey) => {
    return api.post(`wechat/user/loginByCode`, {
        code: code,
        redisKey
    })
}

export const getQrCodeInfoByRedisKey = (redisKey) => {
    return api.get(`wechat/user/qrcodeInfo/${redisKey}`, {
    })
}

export const wechatTips = () => {
    return api.get(`wechat/user/wechatTips`, {
    })
}



